import type {
  Contract,
  LeadConvertorResponseBody,
  Metric,
  Opportunity,
  Product,
  ProductFamily,
  ServiceStatusInfo,
  Subscription,
} from '../../policyholders/resilience/types';
import { ServiceHandler } from '../../utils';

const resilienceBasePath = '/api/resilience/v1';
const configuratorBasePath = `${resilienceBasePath}/configurator`;

export const getProductFamilies = ServiceHandler<unknown, ProductFamily[]>({
  url: `${configuratorBasePath}/product-families`,
  method: 'GET',
});

export const getSubscriptions = ServiceHandler<unknown, Subscription[]>({
  url: `${configuratorBasePath}/subscriptions`,
  method: 'GET',
});

export const getProductFamilyById = ServiceHandler<unknown, ProductFamily>({
  url: `${configuratorBasePath}/product-families/:id`,
  method: 'GET',
});

export const getProductFamilyByCode = ServiceHandler<unknown, ProductFamily>({
  url: `${configuratorBasePath}/product-families/code/:code`,
  method: 'GET',
});

export const getProductsByProductFamilyId = ServiceHandler<unknown, Product[]>({
  url: `${configuratorBasePath}/product-families/:id/products`,
  method: 'GET',
});

export const leadConvertor = ServiceHandler<unknown, LeadConvertorResponseBody>(
  {
    url: `${resilienceBasePath}/lead-requests/convert-lead-to-opportunity`,
    method: 'POST',
  }
);

export const getOpportunities = ServiceHandler<any, Opportunity[]>({
  url: `${configuratorBasePath}/opportunities`,
  method: 'GET',
});

export const addCRSInterestedProductFamily = ServiceHandler<unknown, unknown>({
  url: `${configuratorBasePath}/interested-product-family`,
  method: 'POST',
});

export const addCRSInterestedProduct = ServiceHandler<unknown, unknown>({
  url: `${configuratorBasePath}/interested-product`,
  method: 'POST',
});

export const getProducts = ServiceHandler<unknown, Product[]>({
  url: `${configuratorBasePath}/products`,
  method: 'GET',
});

export const getContracts = ServiceHandler<unknown, Contract[]>({
  url: `${configuratorBasePath}/contracts`,
  method: 'GET',
});

export const getAllMetrics = ServiceHandler<unknown, Metric[]>({
  url: `${resilienceBasePath}/metrics`,
  method: 'GET',
});

export const createMetrics = ServiceHandler<unknown, Metric>({
  url: `${resilienceBasePath}/metrics`,
  method: 'POST',
});

export const getServiceStatusInfo = ServiceHandler<
  unknown,
  ServiceStatusInfo[]
>({
  url: `${resilienceBasePath}/service/status`,
  method: 'GET',
});

export const activateWizer = ServiceHandler<unknown, unknown>({
  url: `${resilienceBasePath}/wizer/activate`,
  method: 'POST',
});
